import React from "react";
import styled from "styled-components";
// import ToggleButton from "@material-ui/lab/ToggleButton";
// import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Typography } from "@mui/material";

const LabelText = styled(Typography)`
  font-size: 13px !important;
  letter-spacing: 0.5px;
  text-transform : capitalize;
`;

const Container = styled.div`
.Mui-selected {
    background-color: #cfa04f !important;
    color: white !important;
  }
  
.Mui-selected h6 {
    color: inherit;
    text-transform : capitalize;
  }
`

const CustomToggle = (props : any) => {
  const handleChange = (event : any, value : any) => {
    if (value === props.optionOne.value || value === props.optionTwo.value) {
      props.onChange(value);
    }
  };

  return (
    <Container>
      <ToggleButtonGroup
        exclusive
        value={props.selected}
        onChange={handleChange}
      >
        <ToggleButton value={props.optionOne.value}>
          <LabelText variant="h6">{props.optionOne.label}</LabelText>
        </ToggleButton>
        <ToggleButton value={props.optionTwo.value}>
          <LabelText variant="h6">{props.optionTwo.label}</LabelText>
        </ToggleButton>
      </ToggleButtonGroup>
    </Container>
  );
};

export default CustomToggle;
